import { createTheme } from "@mui/material/styles";
import "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    accent: Palette["primary"];
  }
  interface PaletteOptions {
    accent?: PaletteOptions["primary"];
  }
}
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1366,
      xl: 1536,
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#1A365D", // Rich navy blue
      light: "#5e728d", //1a365d
      dark: "#1a365d",
      contrastText: "#FFFFFF", // White text for contrast
    },
    accent: {
      main: "#9b87f5", // Purple
      light: "#B8C7F4",
      dark: "#153084",
      contrastText: "#FFFFFF", // White text for contrast
    },
    secondary: {
      main: "#C69F26", // Gold accent
      light: "#AEAEAE",
      dark: "#3B3B3B",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F7F9FC", // Light Gray as the background
      paper: "#FFFFFF", // White for surfaces like cards
    },
    text: {
      primary: "#333333", // Dark text for readability on light backgrounds
      secondary: "#666666",
    },
    grey: {
      100: "#E6E6E6", // Light Gray
      500: "#808080", // Mid Gray
      900: "#333333", // Dark Gray
    },
    error: {
      main: "#D32F2F", // Standard error red
    },
    warning: {
      main: "#FFA726", // Amber
    },
    success: {
      main: "#4CAF50", // Green
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: "2.5rem", fontWeight: 700 },
    h2: { fontSize: "2rem", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.primary.main,
        }),
      },
    },
    /*
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          backgroundColor: ownerState.dark
            ? theme.palette.primary.dark
            : theme.palette.primary.light,
        }),
      },
    },
    */
    MuiToggleButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }),
      },
    },
  },
});

export default theme;

// import { createTheme } from "@mui/material/styles";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#9b87f5", // Primary Purple
//       light: "#D6BCFA", // Light Purple
//       dark: "#7E69AB", // Secondary Purple
//     },
//     secondary: {
//       main: "#1EAEDB", // Light Blue
//       light: "#D3E4FD", // Soft Blue
//       dark: "#1A1F2C", // Navy
//     },
//     background: {
//       default: "#FFFFFF",
//       paper: "#FFFFFF",
//     },
//     text: {
//       primary: "#1A1F2C", // Navy
//       secondary: "#8E9196", // Neutral Gray
//     },
//     error: {
//       main: "#FD4D4D", // Error color
//     },
//     warning: {
//       main: "#FFA500", // Warning color
//     },
//     info: {
//       main: "#1EAEDB", // Info color (Light Blue)
//     },
//     success: {
//       main: "#4CAF50", // Success color
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//       fontSize: "2.5rem",
//     },
//     h2: {
//       fontWeight: 600,
//       fontSize: "2rem",
//     },
//     h3: {
//       fontWeight: 600,
//       fontSize: "1.5rem",
//     },
//     h4: {
//       fontWeight: 600,
//       fontSize: "1.25rem",
//     },
//     h5: {
//       fontWeight: 600,
//       fontSize: "1.125rem",
//     },
//     h6: {
//       fontWeight: 600,
//       fontSize: "1rem",
//     },
//   },
//   shape: {
//     borderRadius: 8,
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           textTransform: "none",
//           fontWeight: 500,
//         },
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
//         },
//       },
//     },
//   },
// });

// export default theme;
